import React, { Component } from "react";

import { withStyles } from "@material-ui/core/styles";

import $ from "jquery";

import {
  TextField,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Input,
  Badge,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Paper,
  Fab,
  Typography
} from "@material-ui/core";
import { ClearOutlined } from "@material-ui/icons";
import NteApprovalForm from "./nte-approval-form";
// import CreateStore from "./create-store";

const styles = theme => ({
  formCls: {
    display: "flex",
    flexGrow: 1
  },
  root: {
    padding: ".5rem",
    width: "100%",

    overflowX: "auto"
  },
  table: {
    minWidth: 650,
    display: "flex"
  },
  checkBoxColor: {
    color: "grey"
  },
  selected: {
    color: "#ff6c00 !important"
  },
  padding25: {
    padding: ".5rem"
  },
  margingrl25: {
    margin: "0 .25rem"
  },
  mb5: {
    marginBottom: ".5rem"
  },
  ml1: {
    marginLeft: ".5rem"
  },
  headerBg1: {
    backgroundColor: "#1b3e71",
    color: "white",
    fontSize: ".85rem"
  },
  badgecls: {
    color: "whitesmoke",
    backgroundColor: "green",
    right: "1.25rem",
    fontSize: "1rem"
  },
  dflex: {
    display: "flex"
  },
  flexend: {
    justifyContent: "flex-end"
  },
  cursorPointer: {
    cursor: "pointer;"
  },
  hide: {
    display: "none"
  },
  fab: {
    backgroundColor: "#cc1e1ede"
  },
  fabHover: {
    backgroundColor: "yellow"
  },
  fabClose: {
    width: "2rem",
    height: "2rem",
    backgroundColor: "#cc1e1ede"
  },
  fullWidth: {
    width: "80%"
  },
  fsColor: {
    backgroundColor: "#989898db"
  },
  flexbetween: {
    justifyContent: "space-between"
  },
  flexbetweentitle: {
    backgroundColor: "#0b409c;",
    "& h6": {
      display: "flex",
      justifyContent: "space-between",

      "& p": {
        fontSize: "1.5rem",
        fontWeight: "bold",
        color: "whitesmoke"
      }
    }
  },
  mainRequest: {
    display: "flex"
  }
});

class NteApproval extends Component {
  constructor() {
    super();

    this.state = {
      isProd: true,

      diagOpen: false,

      approved: true,
      firstName: "",
      lastName: "",
      declineReason: ""
    };
  }

  componentWillMount = () => {};

  propertyChangedEvent = (property, value) => {
         
    this.setState({
      [property]: value
    });
  };

  declineReason = (property, value) => {
    this.setState({
      [property]: value
    });
  };

  handleDiagOpen = () => {
    this.setState({
      diagOpen: true
    });
  };

  handleDiagClose = () => {
    this.setState({
      diagOpen: false
    });
  };

  handleNTEApproval = () => {

    const { approved,  firstName, lastName, declineReason } = this.state;
    const contact = `${firstName} ${lastName}`;

    console.log({ approved, contact, declineReason });

    this.sendApproval();
  };

  sendApproval = () => {
    let url = this.state.isProd
    ? `/api/setNteApproval`
    : `https://localhost:44331/api/setNteApproval`;


    const { approved,  firstName, lastName, declineReason } = this.state;
    const contact = `${firstName} ${lastName}`;
// let x = { ordernumber:this.props.workOrder,  nteid: this.props.nteid, isaccepted: approved, declinedreason: declineReason, contact   };

  $.ajax({
    type: "POST",
    url: url,
    data: { ordernumber:this.props.workOrder,  nteid: this.props.nteid, isaccepted: approved, declinedreason: declineReason, contact    },
    success: result => {
      debugger;

      let resultFormed = JSON.parse(result);

      if (resultFormed.result && resultFormed.isSuccessful) {
        this.props.nteEvent(resultFormed.result.NTE,resultFormed.result.NteDetail)
      }
    },
    error: result => {
      console.error(result);
    }
  });

  this.setState({
    diagOpen: false
  })
  }

  resetStore = () => {
    this.setState({
      storeNumber: null,
      streetAddress: null,
      city: null,
      state: null,
      zipCode: null
    });
  };

  fieldMissing = () => {
    if (this.state.approved) {
      return false;
    }
    
    if(!this.fieldIsInValid(this.state.declineReason))
    {
        console.log({declineReasonx: this.state.declineReason.trim().length})
    }
    

    return (
      this.fieldIsInValid(this.state.firstName) ||
      this.fieldIsInValid(this.state.lastName) ||
      this.fieldIsInValid(this.state.declineReason) ||
      this.state.declineReason.trim().length < 13
    );
  };

  fieldIsInValid = field => {
    return field === null || field === "";
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.mainRequest}>
        <Button
        disabled={this.props.isDisabled}
          variant="contained"
          color="primary"
          className={[classes.button, classes.mt1, classes.mb0].join(" ")}
          onClick={this.handleDiagOpen}
        >
          Approve / Decline Nte
        </Button>

        <Dialog
          fullWidth={true}
          maxWidth="sm"
          // fullScreen
          open={this.state.diagOpen}
          onClose={this.handleDiagClose}
        >
          <DialogTitle
            id="alert-dialog-title"
            className={classes.flexbetweentitle}
          >
            <Typography
              //  variant="h4"
              className={classes.mbwait}
            >
              NTE Approval
            </Typography>
            <Fab
              color="primary"
              title="Close"
              className={classes.fabClose}
              onClick={this.handleDiagClose}
            >
              <ClearOutlined />
            </Fab>
          </DialogTitle>

          <DialogContent>
            <NteApprovalForm propertyChangedEvent={this.propertyChangedEvent} ></NteApprovalForm>
          </DialogContent>

          <DialogActions>
            <Button
              onClick={this.handleDiagClose}
              color="default"
              variant="outlined"
            >
              Cancel
            </Button>
            <Button
              disabled={this.fieldMissing()}
              onClick={this.sendApproval}
              color="primary"
              variant="contained"
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(NteApproval);
